import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';



const  PopupTable = (props) => {    
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const rows = props?.props;
  const objectKeys = Object.keys(rows[0]);
  const objectKeysReduced = objectKeys.filter(x => x !== "__rowNum__")

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
                <TableCell><strong>Sl.No.</strong></TableCell>
                {
                  objectKeysReduced.map((item, index)=>{
                    return(                       
                      <TableCell key={index}><strong>{item}</strong></TableCell>
                        )                      
                  })
                }           
            </TableRow>
          </TableHead>
          <TableBody>          
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, key) => {
                return (
                  <TableRow key={key}>
                    <TableCell>{(page)*(rowsPerPage)+key+1}</TableCell>
                   {objectKeysReduced.map((item, index)=>{
                    return(
                    <TableCell key={index}>{row[item]} </TableCell>
                    )
                    })               
                    }
                     
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export default PopupTable;
